import { apiAuthClient } from '../../helpers';
import { GetOrganisationsResponseType } from '../types/getOrganisationsTypes';

export const getOrganisations = async () => {
  const url = `/organisations`;
  const { data } = await apiAuthClient.get<GetOrganisationsResponseType>(url);
  return data.data;
};
